import { jsx as _jsx } from "react/jsx-runtime";
import defaultsDeep from 'lodash.defaultsdeep';
import { useMemo } from 'react';
import { OrganizationContext } from '../contexts/OrganizationContext.js';
var defaultOrganizationId = 'org123';
export var defaultTestOrganization = {
    id: defaultOrganizationId,
    configuration: {
        servingExperimentAllowed: true
    },
    createdDate: 1610647025895,
    displayName: 'Test Organization',
    owner: {
        email: 'test123@coveo.com'
    },
    publicContentOnly: false,
    readOnly: false,
    type: 'Organization'
};
export var defaultTestDefinition = {
    organizationId: defaultOrganizationId,
    baseLicenseTemplateId: 'Enterprise',
    modifiers: [],
    overrides: []
};
export var TestOrganizationProvider = function TestOrganizationProvider(param) {
    var children = param.children, organization = param.organization, definition = param.definition;
    var organizationModel = useMemo(function() {
        return defaultsDeep({}, organization, defaultTestOrganization);
    }, [
        organization
    ]);
    var organizationDefinition = useMemo(function() {
        return defaultsDeep({}, definition, defaultTestDefinition);
    }, [
        definition
    ]);
    return /*#__PURE__*/ _jsx(OrganizationContext.Provider, {
        value: {
            organizationModelQuery: {
                data: organizationModel,
                isLoading: false,
                isPending: false,
                isError: false,
                isSuccess: true
            },
            organizationDefinitionQuery: {
                data: organizationDefinition,
                isLoading: false,
                isPending: false,
                isError: false,
                isSuccess: true
            }
        },
        children: children
    });
};

//# sourceMappingURL=TestOrganizationProvider.js.map